import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import type { ITraveler } from "@hopper-b2b/types";
import { RadioGroup } from "@tenant/ui";
import { TravelerItemComponent } from "../TravelerItemComponent";
import styles from "../TravelerItemComponent/styles.module.scss";

export interface TravelerSelectionComponentProps
  extends PlatformComponentProps {
  travelerList: ITraveler[];
  handleSelectTraveler: (travelerId: string) => void;
  handleEdit: (travelerId: string) => void;
  handleDelete: (travelerId: string) => void;
  selectedTravelerId: string;
  disabled?: boolean;
}

export const TravelerList = ({
  travelerList,
  handleSelectTraveler,
  // selectedTravelerId may undefined, pass in empty string so RadioGroup stays as a controlled component and not uncontrolled to controlled
  selectedTravelerId = "",
  handleEdit,
  handleDelete,
  disabled,
}: TravelerSelectionComponentProps) => {
  const [, cn] = useModuleBEM(styles, "TravelerList");

  if (travelerList.length === 0) {
    return null;
  }

  const options = travelerList.map((traveler) => ({
    value: traveler.id,
    labelComponent: ({ id, labelId }: { id: string; labelId?: string }) => (
      <TravelerItemComponent
        traveler={traveler}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        disabled={disabled}
        id={id}
        labelId={labelId}
      />
    ),
  }));

  return (
    <RadioGroup
      disabled={disabled}
      density="compact"
      options={options}
      classNames={{
        container: cn("traveler-option-content"),
        itemContainer: cn("traveler-item", { disabled }),
      }}
      onSelectValue={handleSelectTraveler}
      selectedOption={selectedTravelerId}
    />
  );
};
